var path = '/activate/invalid/invalid.html';
var html = "<md-card class=has-circle-icon> <md-card-header> <md-card-header-text> <h1 class=\"md-title circle-icon error\">{{::route.title}}</h1> <p class=\"md-subhead margin-bottom\"> <nobr>Contact <a href=mailto:clientsuccess@blippar.com target=_blank>clientsuccess@blippar.com</a> to get help.</nobr> </p> </md-card-header-text> </md-card-header> </md-card> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./activate/invalid/invalid.html
// module id = 272
// module chunks = 0